import React from "react";
import { Link, useNavigate } from "react-router-dom";
import moulogo from "../../assets/mouLogo.png";
import Button from "../Button";

const NavbarBlog = () => {
  const navigate = useNavigate();

  const links = [
    { label: "Inicio", href: "/blog" },
    { label: "Educación financiera", href: "/blog/educacion-financiera" },
    { label: "Negocios", href: "/blog/negocios" },
    { label: "Bienestar y sostenibilidad", href: "/blog/bienestar" },
    { label: "Innovación", href: "/blog/innovacion" },
    { label: "Tendencias", href: "/blog/tendencias" },
    { label: "Actualidad", href: "/blog/actualidad" },
  ];

  return (
    <nav className="fixed top-12 left-0 w-full bg-[#e8f2f4] p-4 hidden lg:flex items-center justify-between shadow-md px-5 z-50">
      <div className="flex items-center">
        <Link to="/">
          <img src={moulogo} alt="MEU Aliado" className="h-12" />
        </Link>
      </div>
      <div className="flex items-center space-x-6">
        <ul className="flex space-x-8 text-blue-700 font-bold">
          {links.map((item) => (
            <li key={item.href}>
              <Link to={item.href} className="hover:underline">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <Button
          text="Iniciar sesión"
          color="bg-blue-600"
          textColor="text-white"
          paddingX="px-4"
          paddingY="py-2"
          border="border-transparent"
          onClick={() => navigate("/personas/iniciar-sesion")}
        />
      </div>
    </nav>
  );
};

export default NavbarBlog;
